/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Box = styled.div`
  display: flex;
  width: 253px;
  position: relative;

  ::after {
    content: '';
    position: absolute;
    top: 48px;
    right: 0;
    width: 1px;
    height: 388px;
    background: ${Palette.PrimaryGray._200};
  }
`;
